module.exports = __webpack_public_path__ + "img/health.2d1e1fc5.svg";